'use client';

import type { FC } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';
import { FaBox } from '../icons';

const placeholderIconVariants = cva(
  'opacity-30 text-disabled',
  {
    variants: {
      size: {
        small: 'text-2xl',
        medium: 'text-5xl',
        large: 'text-7xl',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
);

interface ItemImageProps {
  src?: string | null;
  alt: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const ItemImage: FC<ItemImageProps> = ({ src, alt, size = 'medium', className }) => {
  if (!src) {
    return (
      <div className={cn('size-full object-contain flex items-center justify-center bg-surface-input', className)}>
        <FaBox className={placeholderIconVariants({ size })} />
      </div>
    );
  }

  return <img src={src} alt={alt} className={cn('size-full object-contain', className)} />;
};
